export class Login {
  readonly email: string;
  readonly password: string;
}